

















































































































































import { Vue, Component } from "../vue-ext";
import { Message, HousingCompany, ArrivalNotice, ArrivalNoticeExtraPerson, SignatureType, User, Apartment, Account, ResidentRoleEnum, ArrivalType } from "../models";

@Component
export default class ArrivalNoticeView extends Vue {
    private housingCompany: HousingCompany | null = null;
    private arrivalNotice: ArrivalNotice = { arrivalType: ArrivalType.PreviousPartyLeaves } as ArrivalNotice;
    private arrivalNoticeExtraPersons: ArrivalNoticeExtraPerson[] = [];
    private signatureTypeList: SignatureType[] = [SignatureType.Application];
    private apartmentList: Apartment[] | null = null;
    private noticeSentSuccessfully: boolean = false;
    private tenant: ResidentRoleEnum;
    private stakeholder: ResidentRoleEnum;
    ArrivalType = ArrivalType;

    private async created() {
        this.root.setTitle(this.$t("menu.arrivalNotice") as string);
        this.root.setIconClass("icon-tuloilmoitukset");
        this.tenant = ResidentRoleEnum.Tenant;
        this.stakeholder = ResidentRoleEnum.Stakeholder;
        this.arrivalNotice.arrivalRole = ResidentRoleEnum.Tenant;

        const housingCompanyId = parseInt(this.$route.params.housingCompanyId, 10);

        if (housingCompanyId) {
            this.housingCompany = await this.root.service.housingCompany.Get(housingCompanyId);
        } else {
            this.housingCompany = this.root.getCurrentHousingCompany() as HousingCompany;
        }

        if (!this.housingCompany) {
            this.root.back();
            return;
        }

        const currentUser = this.root.getCurrentUser() as User; 
        const account = this.root.getCurrentAccount() as Account;
        this.apartmentList = await this.root.service.housingCompany.GetApartmentList(this.housingCompany.housingCompanyId);

        this.arrivalNotice.firstName = currentUser.firstName;
        this.arrivalNotice.lastName = currentUser.lastName;
        this.arrivalNotice.phone = currentUser.phone;
        this.arrivalNotice.email = currentUser.email;

        this.arrivalNotice.signatureType = SignatureType.Application;

        this.arrivalNotice.accountId = account.accountId;
    }

    private addExtraPerson(e: any) {
        e.preventDefault();
        this.arrivalNoticeExtraPersons.push({} as ArrivalNoticeExtraPerson);
    }

    private removeExtraPerson(e: any) {
        e.preventDefault();
        this.arrivalNoticeExtraPersons.pop();
    }

    private async save() {
        if (!this.arrivalNotice.moveInDate) {
            return;
        }

        this.arrivalNotice.extraPersons = this.arrivalNoticeExtraPersons;
        const res = await this.root.service.notice.SendArrivalNotice(this.arrivalNotice);
        
        if (!res.isError) {
            this.noticeSentSuccessfully = true;
        }
    }
}
